import { categories } from '@/mocks/campusData';
import { SectionHeading } from './common';

export default function CategoriesRail({ onPick }: { onPick: (catKey: string) => void }) {
  return (
    <section id="categories" className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        kicker="吃瓜栏目"
        title="按剧情进度，挑你想追的瓜"
        desc="每一个瓜都有它的发展节奏。想追新的、等反转、看辟谣还是等定论，先从栏目下手，不会追乱也不会追丢。"
      />

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6">
        {categories.map((cat) => (
          <button
            key={cat.key}
            type="button"
            onClick={() => onPick(cat.key)}
            className="group relative overflow-hidden rounded-xl border border-stone-200 bg-white p-4 text-left transition hover:border-red-300 md:p-5"
          >
            <div className="relative mb-4 h-24 overflow-hidden rounded-lg md:h-28">
              <img
                src={cat.img}
                alt={`${cat.name}栏目配图：${cat.desc}`}
                title={`校园吃瓜 ${cat.name}`}
                className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
              />
              <span className={`absolute inset-0 bg-gradient-to-t from-black/35 to-transparent`} />
              <i
                className={`${cat.icon} absolute bottom-2 left-2 flex h-7 w-7 items-center justify-center rounded-md bg-white/85 text-base text-stone-800`}
              />
            </div>
            <div className="flex items-center justify-between gap-2">
              <h3 className="text-sm font-bold text-stone-900 md:text-base">{cat.name}</h3>
              <span className="whitespace-nowrap rounded-full bg-stone-100 px-2 py-0.5 text-[11px] font-medium text-stone-500">
                {cat.count} 篇
              </span>
            </div>
            <p className="mt-1.5 text-xs leading-relaxed text-stone-500 md:text-[13px]">{cat.desc}</p>
          </button>
        ))}
      </div>
    </section>
  );
}